import { aomGraphqlRequest } from 'core/utils/backend-service';
import { mapPOCFieldAttributeFromApiToModel } from './poc-fields.mapper';
import { getPOCFields } from './poc-fields.queries';
import { POCFieldAttribute } from './poc-fields.type';

// Temporal filter to avoid active field
export const getPocFields = (): Promise<POCFieldAttribute[]> =>
    aomGraphqlRequest(getPOCFields()).then((response) =>
        response.data.attributes.filter((f) => f.attribute !== 'active').map(mapPOCFieldAttributeFromApiToModel)
    );
